import React, { useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Guards a dialog against losing a half-filled form on Esc / click-outside / X.
 * Wire `requestClose` into the Dialog's onOpenChange. When the form is dirty a
 * confirm appears; an untouched form closes straight away (no nagging).
 *
 * const guard = useUnsavedGuard(isDirty, () => setOpen(false));
 * <Dialog open={open} onOpenChange={guard.requestClose}> ... </Dialog>
 * <DiscardDialog guard={guard} />
 */
export function useUnsavedGuard(isDirty, doClose) {
  const [pending, setPending] = useState(false);
  const requestClose = (open) => {
    if (open) return;            // opening is handled by the caller
    if (isDirty) setPending(true);
    else doClose();
  };
  return {
    requestClose,
    pending,
    confirm: () => { setPending(false); doClose(); },
    cancel: () => setPending(false),
  };
}

export const DiscardDialog = ({ guard }) => (
  <AlertDialog open={guard.pending} onOpenChange={(o) => !o && guard.cancel()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Wijzigingen weggooien?</AlertDialogTitle>
        <AlertDialogDescription>Je hebt gegevens ingevuld die nog niet zijn opgeslagen.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Terug</AlertDialogCancel>
        <AlertDialogAction data-testid="discard-confirm" onClick={guard.confirm} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
          Weggooien
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
